import { TagManagement } from "@selector/shared/components";
import type { ComponentProps, FC } from "react";
import type { GridCard } from "widgets";
import { Card } from "widgets";

type TagManagementCardProps = GridCard & ComponentProps<typeof TagManagement>;

export const TagManagementCard: FC<TagManagementCardProps> = (props) => {
  return (
    <Card title={"Tags"}>
      <TagManagement projectId={props.projectId} />
    </Card>
  );
};
